// Helper function to convert form data to FormData for file uploads
export const prepareFormData = (formData) => {
  const formDataToSend = new FormData();
  
  // Append all fields to FormData
  Object.keys(formData).forEach(key => {
    // Handle file objects and arrays
    if (formData[key] instanceof File) {
      formDataToSend.append(key, formData[key]);
    } else if (Array.isArray(formData[key])) {
      // Handle arrays (like industries, focusAreas, etc.)
      formData[key].forEach((item, index) => {
        formDataToSend.append(`${key}[${index}]`, item);
      });
    } else if (formData[key] !== null && formData[key] !== undefined) {
      // Handle all other non-null/undefined values
      formDataToSend.append(key, formData[key]);
    }
  });
  
  return formDataToSend;
};

// Helper function to handle file previews
export const getFilePreview = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.readAsDataURL(file);
  });
};

// Helper function to validate file type
export const validateFileType = (file, allowedTypes) => {
  if (!file) return true;
  return allowedTypes.includes(file.type);
};

// Helper function to validate file size
export const validateFileSize = (file, maxSizeMB) => {
  if (!file) return true;
  const maxSize = maxSizeMB * 1024 * 1024; // Convert MB to bytes
  return file.size <= maxSize;
};
